import $ from 'jquery';
import 'slick-carousel';
import AOS from 'aos';
import 'aos/dist/aos.css';
window.$ = window.jQuery = $;
require('bootstrap');
require('particles.js/particles');
let particleconfig = require('./particlesjs-config.json');

$(document).ready(function() {
    AOS.init({duration: 600,offset:100});

    $(document).scroll(function () {
        var $nav = $("#main-header");
        $nav.toggleClass('scrolled', $(this).scrollTop() > $nav.height());
    });

    $('.particle').each(function(){
      particlesJS($(this).attr('id'), particleconfig);
    });

    $(".home-project-list").slick({
        infinite: true,
        slidesToShow: 3,
        arrow: true,
        dots: false,
        centerMode: false,
        slidesToScroll: 3,
        responsive: [{
            breakpoint: 960,
            settings: {
              centerMode: false,
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },{
            breakpoint: 720,
            settings: {
              slidesToShow: 3,
              centerMode: false,
              arrow: false,
              dots: true,
              slidesToScroll: 3
            }
          },{
            breakpoint: 560,
            settings: {
              slidesToShow: 2,
              centerMode: false,
              arrow: false,
              dots: true,
              slidesToScroll: 2
            }
          },{
            breakpoint: 420,
            settings: {
              slidesToShow: 1,
              centerMode: false,
              arrow: false,
              dots: true,
              slidesToScroll: 1
            }
          }]
      });
    
      $('.mobile-toggle').click(function(){
          $(this).toggleClass('active');
          $('.site-header-navs').toggleClass('active');
      });
});
